import IconDeleteButton from "../../images/icon_delete_button.svg";
import { Code, Container, Name } from "./VolanteAdditionalServicesCartStyles";
import { ContentModal } from "./VolanteServiceSidebarStyles";

export function VolanteAdditionalServicesCart(props) {
  const { selectedState } = props;
  const [selected] = selectedState;

  return (
    <ContentModal>
      <div style={{ width: "100%" }}>
        <div
          style={{
            fontFamily: "Montserrat",
            fontSize: 16,
            color: "#30345C",
            fontStyle: "normal",
            marginBottom: 10,
          }}
        >
          <div
            style={{
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: "3rem",
              marginBottom: "5rem",
            }}
          >
            <b>Servicios Adicionales</b>
          </div>
          <div>
            {selected.map((service, i) => {
              return (
                <Container key={i}>
                  <div style={{ width: "35rem", marginLeft: "1.6rem" }}>
                    <Name>{service.service_name}</Name>
                    <div>Cantidad: {service.amount}</div>
                  </div>
                  <div>
                    <Code>{service.sap_code}</Code>
                  </div>
                  <div style={{ marginRight: "1.6rem" }}>
                    <img
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        props.onRemoveService(service);
                      }}
                      src={IconDeleteButton}
                      alt=""
                    />
                  </div>
                </Container>
              );
            })}
          </div>
        </div>
      </div>
    </ContentModal>
  );
}
